module.exports = {"TXTCLI_Address":{"id":"TXTCLI_Address","defaultMessage":"Cím","flags":["TRACK"],"track":"Address"}}